import { actionToPath, pathToAction, ReceivedAction } from 'redux-first-router';
import queryString from 'query-string';

import routesGenerator from './routesGenerator';

const routesMap = routesGenerator();

export const getPath = (action: ReceivedAction) => {
  return actionToPath(action, routesMap, queryString);
};

export const getCurrentRouteObject = () => {
  const action = pathToAction(window.location.pathname, routesGenerator());
  return routesMap[action.type];
};

export const isAuthenticationNeeded = (routeName: string) =>
  Boolean(routesMap[routeName]?.needsAuthentication);
